export default "__VITE_ASSET__BG9Qp3Ie__"